import React, { Component } from "react";
import PropTypes from "prop-types";
import { StorageHandler } from "C4";
import { storageKeys } from "settings";

export default class BackVideo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      video: null,
      image: null,
      size: null,
      ready: false,
    };
  }

  componentDidMount() {
    this.loadBgImage();
  }

  async loadBgImage() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        video: appInfo.backgroundVideo,
        image: appInfo.backgroundImage,
        size: {
          width: document.body.clientWidth,
          height: document.body.clientHeight,
        },
      });
    }
  }

  render() {
    const { video, image, size, ready } = this.state;
    const { darken } = this.props;

    return (
      <video
        className={`backgroundVideo ${darken && "darken"}`}
        src={video}
        autoPlay
        muted
        loop
        preload="auto"
        poster={image}
        height={size && size.height}
        width={size && size.width}
        onLoadedData={() => {
          if (!ready) this.setState({ ready: true });
        }}
        style={{ opacity: ready ? 1 : 0 }}
      >
        <track kind="captions" />
      </video>
    );
  }
}

BackVideo.propTypes = {
  darken: PropTypes.bool,
};

BackVideo.defaultProps = {
  darken: false,
};
